export default __webpack_public_path__ + "static/media/arrow_right.6a7d995d.svg";